import { useState } from 'react';
import IconAdd from '../../components/icons/IconAdd';
import CommunicationTypePicker from './CommunicationTypePicker';
import NotificationBlockCard from './NotificationBlockCard';
import { serializeNotificationBlocks } from './renderNotificationBlocks';
import { NOTIFICATION_BLOCK_TYPE_LIST } from '../../variables/notificationBlockTypes';
import * as api from './api';
import '../../css/modals.css';
import '../../css/exercise-templates.css';
import '../../css/communications.css';

let blockKeySeq = 1;
function newBlockId() { return 'ab' + (blockKeySeq++) + '-' + Date.now(); }

// "Створити новий" from a student's Платформа tab - author a brand new
// Notification template AND assign it to this student in one flow (two
// calls: createNotification then assignNotification), rather than
// navigating away to the full Komunikaty builder and losing context. The
// resulting template still shows up in the Komunikaty module afterwards
// (reusable for other students later) - this is just a fast path, not a
// separate storage mechanism. Content uses the same block-list model as
// the full Builder.jsx (heading/text/icon cards), not a single textfield.
export default function AssignNewCommunicationModal({ isOpen, studentId, onClose, onAssigned }) {
   const [title, setTitle] = useState('');
   const [type, setType] = useState('INFO');
   const [blocks, setBlocks] = useState([]);
   const [addPickerOpen, setAddPickerOpen] = useState(false);
   const [saving, setSaving] = useState(false);

   if (!isOpen) return '';

   const stopProp = (e) => e.stopPropagation();

   const reset = () => {
      setTitle('');
      setType('INFO');
      setBlocks([]);
      setAddPickerOpen(false);
   };
   const handleClose = () => {
      reset();
      onClose();
   };

   const addBlock = (blockType) => {
      const def = NOTIFICATION_BLOCK_TYPE_LIST.find((t) => t.type === blockType);
      setBlocks((prev) => [...prev, { id: newBlockId(), type: blockType, ...(def ? def.defaultConfig : {}) }]);
      setAddPickerOpen(false);
   };
   const saveBlock = (index, updated) => setBlocks((prev) => prev.map((b, i) => (i === index ? updated : b)));
   const moveBlock = (index, dir) => {
      setBlocks((prev) => {
         const next = [...prev];
         const target = index + dir;
         if (target < 0 || target >= next.length) return prev;
         [next[index], next[target]] = [next[target], next[index]];
         return next;
      });
   };
   const deleteBlock = (index) => setBlocks((prev) => prev.filter((_, i) => i !== index));

   const handleSubmit = (e) => {
      e.preventDefault();
      if (saving || !title.trim()) return;
      setSaving(true);
      api.createNotification({ title: title.trim(), type, content: serializeNotificationBlocks(blocks) })
         .then((res) => api.assignNotification(studentId, res.data.id))
         .then(() => {
            reset();
            onAssigned();
         })
         .catch((err) => console.log(err))
         .finally(() => setSaving(false));
   };

   return (
      <div className='modal-update' onClick={handleClose} style={{ display: 'flex' }}>
         <div className='modal-window' onClick={stopProp} style={{ maxWidth: 640, maxHeight: '85vh', overflowY: 'auto' }}>
            <h3 className='modal-w-title'>Нова інформація для студента</h3>
            <form onSubmit={handleSubmit}>
               <div className='flex-from-input-wraper exercise-template-field' data-label='Назва'>
                  <input className='submit-field from-input txt-c' type='text' autoFocus
                     placeholder='Назва' value={title} onChange={(e) => setTitle(e.target.value)} />
               </div>
               <CommunicationTypePicker value={type} onChange={setType} showHint />

               <p className='exercise-block-field-label' style={{ marginTop: 14, textAlign: 'left' }}>Блоки повідомлення</p>
               {blocks.map((block, i) => (
                  <NotificationBlockCard key={block.id} block={block}
                     canMoveUp={i > 0} canMoveDown={i < blocks.length - 1}
                     onMove={(dir) => moveBlock(i, dir)}
                     onSave={(updated) => saveBlock(i, updated)}
                     onDelete={() => deleteBlock(i)} />
               ))}

               <div className='exercise-block-add-trigger' onClick={() => setAddPickerOpen((prev) => !prev)}>
                  <IconAdd />
                  <span>Додати блок</span>
               </div>
               {addPickerOpen ? (
                  <div className='exercise-block-type-picker'>
                     <div className='exercise-block-type-row'>
                        {NOTIFICATION_BLOCK_TYPE_LIST.map((t) => (
                           <div key={t.type} className='exercise-block-type-chip' style={{ '--accent': t.accent }} onClick={() => addBlock(t.type)}>
                              {t.label}
                           </div>
                        ))}
                     </div>
                  </div>
               ) : ''}

               <button type='submit' className='form-button txt-c' disabled={saving || !title.trim()} style={{ marginTop: 14 }}>
                  {saving ? 'Завантаження...' : 'Створити та додати'}
               </button>
            </form>
         </div>
      </div>
   );
}
